import React from 'react';
import style from './style.module.scss';
import { Pagination, PaginationProps } from '..';

export interface PaginationBarProps {
    pagination: PaginationProps;
    children?: React.ReactNode;
}

export function PaginationBar(props: PaginationBarProps) {
    return (
        <div className={style.pagination_bar}>
            {props.children}
            <Pagination {...props.pagination} />
        </div>
    );
}
